<section class="fb-blog-content i-font-primary py-4">
	<img class="rounded-lg mb-4 max-h-[250px] object-cover aspect-video w-full"
		 [src]="storyDetails.bannerImageDesktop" [alt]="storyDetails.title">
	<h1 id="web-development">{{storyDetails.title}}</h1>
	<div class="w-full flex justify-end items-center gap-2 mb-2">
		<div class="bg-[#dfd0bb] p-2 rounded-md">
			<img class="w-8 h-8" src="assets/img/logo_black.svg" alt="">
		</div>
		<div class="text-xs">
			<div class="text-sm font-bold capitalize">{{storyDetails.storyContentCategory.name.toLowerCase()}}</div>
			<div>Published on {{storyDetails.lastUpdateTime | formatDate}}</div>
			<div class="font-semibold text-[#7d5b1f]">Reading Time: {{storyDetails.readingTime}} Minute Read</div>
		</div>
	</div>
	<div class="w-full flex lg:hidden justify-end">
		<a [routerLink]="'/stories/'+ storyDetails.slug + '/'+ storyDetails.id"
		   [fragment]="'story-products'"
		   class="w-max ml-1 mb-4 bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
			transition flex items-center justify-center gap-2 capitalize text-xs">View {{storyDetails.title.toLowerCase()}} Products</a>
	</div>
	<div class="text-sm my-5" [innerHTML]="storyDetails.description | safeHtml"></div>
	<ng-container *ngFor="let template of storyDetails.storyContentSectionList; let i = index">
		<ng-container [ngSwitch]="template.templateType">
			<div *ngSwitchCase="1" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>

				<div class="flex flex-col lg:flex-row justify-between items-start gap-5 mt-4 mb-8">
					<a *ngIf="template.image1Link" target="_blank" [href]="template.image1Link"
					   class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md max-h-[450px]"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
						<div *ngIf="template.caption1"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
					</a>
					<div *ngIf="!template.image1Link" class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
						<div *ngIf="template.caption1"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
					</div>

					<div>
						<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>
						<div class="text-sm" [innerHTML]="template.paragraph1 | safeHtml">
						</div>
						<a *ngIf="template.ctaLink1"
						   [href]="template.ctaLink1"
						   target="_blank"
						   class="w-max capitalize bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-2">
							{{template.ctaButtonName1 ? template.ctaButtonName1: 'Discover More'}}
						</a>
					</div>

				</div>
			</div>

			<div *ngSwitchCase="2" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>

				<div class="flex flex-col-reverse lg:flex-row justify-between items-start gap-5 mt-4 mb-8">
					<div>
						<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>
						<div class="text-sm" [innerHTML]="template.paragraph1 | safeHtml">
						</div>
						<a *ngIf="template.ctaLink1"
						   [href]="template.ctaLink1"
						   target="_blank"
						   class="w-max capitalize bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-2">
							{{template.ctaButtonName1 ? template.ctaButtonName1: 'Discover More'}}
						</a>
					</div>

					<a *ngIf="template.image1Link" target="_blank" [href]="template.image1Link"
					   class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md max-h-[450px]"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
						<div *ngIf="template.caption1"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
					</a>
					<div *ngIf="!template.image1Link"
						 class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
						<div *ngIf="template.caption1"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
					</div>
				</div>
			</div>
			<div *ngSwitchCase="3" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>

				<div class="flex flex-col lg:flex-row justify-between items-stretch gap-5 mt-4 mb-8">
					<img lazyLoad (click)="openVideo(template.video1)" class="w-full cursor-pointer object-cover h-auto rounded-md md:w-[48%]"
						 [src]="template.image1"
						 [alt]="template.image1Alt">
					<div>
						<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>
						<div [innerHTML]="template.paragraph1 | safeHtml" class="text-sm">
						</div>
						<a *ngIf="template.ctaLink1"
						   [href]="template.ctaLink1"
						   target="_blank"
						   class="w-max capitalize bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-2">
							{{template.ctaButtonName1 ? template.ctaButtonName1: 'Discover More'}}
						</a>
					</div>
				</div>
			</div>

			<div *ngSwitchCase="4" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>

				<div class="flex flex-col lg:flex-row justify-between items-stretch gap-5 mt-4 mb-8">
					<div>
						<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>
						<div [innerHTML]="template.paragraph1 | safeHtml" class="text-sm">
						</div>
						<a *ngIf="template.ctaLink1"
						   [href]="template.ctaLink1"
						   target="_blank"
						   class="w-max capitalize bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-2">
							{{template.ctaButtonName1 ? template.ctaButtonName1: 'Discover More'}}
						</a>
					</div>
					<img lazyLoad (click)="openVideo(template.video1)" class="w-full cursor-pointer object-cover h-auto rounded-md md:w-[48%]"
						 [src]="template.image1"
						 [alt]="template.image1Alt">
				</div>
			</div>

			<div *ngSwitchCase="5" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>

				<div class="flex flex-col lg:flex-row justify-between items-stretch gap-5 mt-4 mb-8">
					<div class="md:flex-[50%]">
						<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>
						<div [innerHTML]="template.paragraph1 | safeHtml" class="text-sm">
						</div>
						<a *ngIf="template.ctaLink1"
						   [href]="template.ctaLink1"
						   target="_blank"
						   class="w-max capitalize bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-2">
							{{template.ctaButtonName1 ? template.ctaButtonName1: 'Discover More'}}
						</a>
					</div>

					<div class="md:flex-[50%]">
						<h4 *ngIf="template.title2" class="i-sub-header mb-2">{{template.title2}}</h4>
						<div [innerHTML]="template.paragraph2 | safeHtml" class="text-sm">
						</div>
						<a *ngIf="template.ctaLink2"
						   [href]="template.ctaLink2"
						   target="_blank"
						   class="w-max capitalize bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-2">
							{{template.ctaButtonName2 ? template.ctaButtonName2: 'Discover More'}}
						</a>
					</div>
				</div>
			</div>
			<div *ngSwitchCase="6" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template,i)" class="i-header">{{template.heading}}</h3>
				<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>

				<div class="flex flex-col lg:flex-row justify-between items-stretch gap-5 mt-4 mb-8">

					<a *ngIf="template.image1Link" target="_blank" [href]="template.image1Link"
					   class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md max-h-[450px]"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
						<div *ngIf="template.caption1"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
					</a>
					<div *ngIf="!template.image1Link"
						 class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
						<div *ngIf="template.caption1"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
					</div>


					<a *ngIf="template.image2Link" target="_blank" [href]="template.image2Link"
					   class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md max-h-[450px]"
							 [src]="template.image2"
							 [alt]="template.image2Alt">
						<div *ngIf="template.caption2"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption2}}</div>
					</a>
					<div *ngIf="!template.image2Link"
						 class="flex flex-col justify-center items-center">
						<img lazyLoad  class="object-cover w-full h-auto rounded-md"
							 [src]="template.image2"
							 [alt]="template.image2Alt">
						<div *ngIf="template.caption2"
							 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption2}}</div>
					</div>
				</div>
			</div>

			<div *ngSwitchCase="7" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>

				<div class="flex flex-col lg:flex-row justify-between items-stretch gap-5 mt-4 mb-8">
					<img lazyLoad (click)="openVideo(template.video1)" class="w-full cursor-pointer object-cover h-auto rounded-md md:w-[48%]"
						 [src]="template.image1"
						 [alt]="template.image1Alt">

					<img lazyLoad (click)="openVideo(template.video2)" class="w-full cursor-pointer object-cover h-auto rounded-md md:w-[48%]"
						 [src]="template.image2"
						 [alt]="template.image2Alt">
				</div>
			</div>

			<div *ngSwitchCase="8" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>

				<div class="flex flex-col justify-center items-center gap-4 mt-4 mb-8">
					<h4 *ngIf="template.title1" class="i-sub-header mb-2 w-full text-left">{{template.title1}}</h4>
					<div [innerHTML]="template.paragraph1 | safeHtml" class="text-sm">
					</div>
					<a *ngIf="template.ctaLink1"
					   [href]="template.ctaLink1"
					   target="_blank"
					   class="w-max capitalize bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-2">
						{{template.ctaButtonName1 ? template.ctaButtonName1: 'Discover More'}}
					</a>
				</div>
			</div>
			<div *ngSwitchCase="9" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>
				<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>

				<div class="fb-template-full w-full flex flex-col justify-center items-center gap-5 mt-4 mb-8">
					<img lazyLoad *ngIf="!template.image1Link" class="w-full object-contain mx-2 h-auto rounded-md max-h-[70vh]"
						 [src]="template.image1"
						 [alt]="template.image1Alt">

					<a *ngIf="template.image1Link" target="_blank" [href]="template.image1Link">
						<img lazyLoad class="object-cover w-full h-auto rounded-md max-h-[70vh]"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
					</a>
					<div *ngIf="template.caption1"
						 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
				</div>
			</div>
			<div *ngSwitchCase="10" class="fb-blog-section my-12">
				<h3 [id]="getTitleId(template, i)" class="i-header">{{template.heading}}</h3>
				<h4 *ngIf="template.title1" class="i-sub-header mb-2">{{template.title1}}</h4>

				<div class="fb-template-full w-full flex flex-col justify-center items-center gap-5 mt-4 mb-8">
					<div class="w-full bg-black rounded-md">
						<img lazyLoad
							 #videoPoster
							 *ngIf="!playVideo"
							 (click)="playVideoInPlace(template.video1)"
							 class="w-full cursor-pointer object-contain object-center rounded-md h-auto max-h-[70vh]"
							 [src]="template.image1"
							 [alt]="template.image1Alt">
						<iframe *ngIf="playVideo"
								[src]="safeURL"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen
								frameborder="0"
								[width]="videoWidth"
								[height]="videoHeight"
								title="YouTube video player">
						</iframe>
					</div>
					<div *ngIf="template.caption1"
						 class="text-[#948467] mt-1 text-sm font-medium">{{template.caption1}}</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
	<div *ngIf="storyDetails.faq" class="fb-blog-content-faq mt-12">
		<h3 [id]="'faq-header'" class="i-header capitalize">{{storyDetails.faq.heading.toLowerCase()}}</h3>
		<div *ngIf="!showCollapsedFaqsContent" class="flex flex-col justify-start items-start gap-4 w-full mt-5">
			<ng-container *ngFor="let question of storyDetails.faq.faqQuestionList">
				<div class="flex justify-center items-start gap-3">
					<div class="bg-gray-200 p-2 pb-0 rounded-md">
						<span class="material-symbols-outlined">live_help</span>
					</div>
					<div class="flex flex-col justify-start items-start">
						<h4 class="i-sub-header">{{question.question}}</h4>
						<p>{{question.answer}}</p>
					</div>
				</div>
			</ng-container>
		</div>

		<fb-blog-details-content-faq *ngIf="showCollapsedFaqsContent" [faqs]="storyDetails.faq"></fb-blog-details-content-faq>
	</div>
	<div *ngIf="storyRecommendedList && storyRecommendedList.length > 0" class="mt-12">
		<h3 class="i-header capitalize mb-5 md:mb-0">More Stories</h3>
		<fb-blog-more-stories [blogRecommendedList]="storyRecommendedList" url="/stories/"></fb-blog-more-stories>
	</div>
</section>
<fb-blog-video-popup (closeVideoPopup)="closeVideoModal()" *ngIf="openVid" [url]="urlLink"></fb-blog-video-popup>
